import Vue from 'vue';

Vue.component('promotion-index', () =>
    import(/* webpackChunkName: 'promotion-index' */ './promotion-index.vue'),
);
Vue.component('promotion-detail', () =>
    import(/* webpackChunkName: 'promotion-detail' */ './promotion-detail.vue'),
);
Vue.component('promotion-approval-index', () =>
    import(/* webpackChunkName: 'promotion-approval-index' */ './approval/promotion-approval-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/promotion/index.js